import { render, staticRenderFns } from "./cardViewer.vue?vue&type=template&id=53ba1f8f&scoped=true"
import script from "./cardViewer.vue?vue&type=script&lang=js"
export * from "./cardViewer.vue?vue&type=script&lang=js"
import style0 from "./cardViewer.vue?vue&type=style&index=0&id=53ba1f8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba1f8f",
  null
  
)

export default component.exports